import React from "react";
import {
  LineChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Line,
} from "recharts";
import { ChartStrategy } from "./ChartStrategy";
import { DYCHARTCOLORS } from "../../../../core/constants/chartStyles";

export class LineChartStrategy extends ChartStrategy {
  render() {
    return (
      <LineChart {...this.commonProps}>
        <CartesianGrid stroke={this.props.gridColor} strokeDasharray="3 3" />
        <XAxis dataKey={this.props.xAxis} {...this.axisProps} />
        <YAxis {...this.axisProps} />
        <Tooltip content={<this.props.CustomTooltip />} />
        <Legend wrapperStyle={{ color: this.props.axisColor, fontSize: 12 }} />
        <Line
          type="monotone"
          dataKey={this.props.yAxis}
          stroke={DYCHARTCOLORS[0]}
          strokeWidth={2}
          dot={{ fill: DYCHARTCOLORS[0] }}
        />
      </LineChart>
    );
  }
}
